import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const TOOLS = [
  { title: "Capital Gain Calculator", desc: "Upload broker PDF/Excel. Get 5-sheet tax report.", icon: "📈", link: "/tools/capital-gain", tag: "Free" },
  { title: "TDS Calculator", desc: "AI-powered TDS section and rate finder.", icon: "🧮", link: "/tools/tds-calculator", tag: "Free" },
  { title: "Bank Statement to Excel", desc: "Convert any bank statement PDF to Excel.", icon: "🏦", link: "/tools/bank-statement", tag: "Free" },
  { title: "Property Capital Gain", desc: "Section 54 tax saving calculator.", icon: "🏠", link: "/tools/property-gain", tag: "Coming Soon" },
  { title: "TDS on Overseas Payments", desc: "DTAA vs Income Tax rate comparison.", icon: "🌏", link: "/tools/overseas-tds", tag: "Paid" },
  { title: "Crypto Capital Gain", desc: "Section 115BBH capital gain calculator.", icon: "🪙", link: "/tools/crypto-gain", tag: "Coming Soon" },
];

const TAG: {[key: string]: {bg: string; color: string}} = {
  "Free":        { bg: "#E2F0D9", color: "#375623" },
  "Paid":        { bg: "#FFF2CC", color: "#7F6000" },
  "Coming Soon": { bg: "#EAE6E0", color: "#5C5C5C" },
};

export default function Dashboard() {
  const [user, setUser] = useState<any>(null);
  const [picture, setPicture] = useState(localStorage.getItem("userPicture") || "");
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      localStorage.setItem("token", token);
      const pic = params.get("picture");
      if (pic) localStorage.setItem("userPicture", pic);
      window.history.replaceState({}, "", "/dashboard");
    }
    const stored = localStorage.getItem("token");
    if (!stored) { navigate("/login"); return; }
    fetch("/api/auth/me", { headers: { Authorization: "Bearer " + stored } })
      .then(r => r.json())
      .then(data => { if (data.email) setUser(data); else navigate("/login"); })
      .catch(() => navigate("/login"));
  }, [navigate]);

  if (!user) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60vh" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ width: "40px", height: "40px", border: "3px solid var(--border)", borderTop: "3px solid #C9A84C", borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 12px" }}></div>
        <p style={{ color: "var(--text-muted)", fontSize: "14px" }}>Loading your dashboard...</p>
      </div>
    </div>
  );

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "32px 24px" }}>

      <div style={{ background: "linear-gradient(135deg, #2C2C2C, #3A3530)", borderRadius: "16px", padding: "28px 32px", marginBottom: "32px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
        <div>
          <h1 style={{ fontSize: "22px", fontWeight: 700, color: "white", marginBottom: "4px" }}>
            Welcome back, <span style={{ color: "#C9A84C" }}>{(user.name || user.email || "").split(" ")[0]}</span>
          </h1>
          <p style={{ color: "#909090", fontSize: "14px" }}>{user.email}</p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span style={{ background: "#C9A84C", color: "#2C2C2C", fontSize: "12px", fontWeight: 700, padding: "4px 12px", borderRadius: "10px" }}>
            {(user.plan || "FREE").toUpperCase()} PLAN
          </span>
          <Link to="/pricing" style={{ background: "transparent", color: "#C9A84C", border: "1.5px solid #C9A84C", padding: "6px 14px", borderRadius: "8px", fontSize: "13px", fontWeight: 600 }}>
            Upgrade
          </Link>
        </div>
      </div>

      <h2 style={{ fontSize: "18px", fontWeight: 700, color: "var(--text-primary)", marginBottom: "20px" }}>All Tools</h2>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px" }}>
        {TOOLS.map((tool, idx) => {
          const tagStyle = TAG[tool.tag] || TAG["Coming Soon"];
          const isComingSoon = tool.tag === "Coming Soon";
          return (
            <Link key={idx} to={tool.link}
              className="tool-card"
              style={{ opacity: isComingSoon ? 0.65 : 1 }}
              onClick={e => { if (isComingSoon) e.preventDefault(); }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
                <span style={{ fontSize: "32px", lineHeight: 1 }}>{tool.icon}</span>
                <span style={{ background: tagStyle.bg, color: tagStyle.color, fontSize: "10px", fontWeight: 700, padding: "2px 8px", borderRadius: "8px" }}>{tool.tag}</span>
              </div>
              <h3 style={{ fontSize: "15px", fontWeight: 700, marginBottom: "6px" }}>{tool.title}</h3>
              <p style={{ fontSize: "12px", lineHeight: "1.5" }}>{tool.desc}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
